/**
 * Test IDs for QA automation.
 */
export const testIds = {
  addressInputPlacePicker: "address-input-place-picker",
  addressInputPlaceSearch: "address-input-place-search",
  addressInputLine1: "address-input-line-1",
  addressInputLine2: "address-input-line-2",
  addressInputCity: "address-input-city",
  addressInputState: "address-input-state",
  addressInputPostalCode: "address-input-postal-code",
  addressInputCountry: "address-input-country",
} as const;
